import api from "PFCore/api";
import { Id } from "PFCore/types";

type DeleteUserResponse = {
  message: string;
};

export const deleteUser = (id: Id): Promise<DeleteUserResponse> =>
  api({
    method: "DELETE",
    url: `saas_admin/users/${id}`,
    apiVersion: 1
  });
